import { Response } from '@candu-ai/first-mate/api';

export const IMAGE_VARIATIONS_API = '/api/first-mate/image-variations';

export type ImageVariationsRequest = {
  image: string | ArrayBuffer;
  n: number;
  model: 'dall-e-2';
};

interface ImageUrl {
  url: string;
}

export type ImageVariationsResponse = Response<{
  res: {
    data: ImageUrl[];
  };
}>;
